import React from "react";
import { Card } from "../atoms";
import DataRow from "./DataRow";
import styled from "styled-components";
import { theme } from "../theme/semanticTheme";

const SectionTitle = styled.h2`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.sectionHeading.fontSize};
  font-weight: ${theme.typography.sectionHeading.fontWeight};
  line-height: ${theme.typography.sectionHeading.lineHeight};
  color: ${theme.colors.primary};
  margin: 0 0 ${theme.spacing.md} 0;
  padding-bottom: ${theme.spacing.sm};
  border-bottom: 1px solid ${theme.colors.border};
`;

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
`;

/**
 * Molecule: SectionCard – card with title + list of label/value rows. Reusable for Received Payment, Total Spend, etc.
 */
export default function SectionCard({ title, rows = [] }) {
  return (
    <Card>
      <SectionTitle>{title}</SectionTitle>
      <Rows>
        {rows.map((row, i) => (
          <DataRow key={i} label={row.label} value={row.value} variant={row.variant} />
        ))}
      </Rows>
    </Card>
  );
}
